import camelcaseKeys from "camelcase-keys";
import { getLiveTrackingUrl } from "./url";

export const track = (token) => {
  if(process.env.NODE_ENV === "development" && process.env.REACT_APP_API_MOCK){
    if (window._DEV_OFFLINE_) {
      return Promise.reject({status: 500});
    }
    return mockData().then((data) => camelcaseKeys(data, { deep: true }));
  } else {
    return fetch(getLiveTrackingUrl(token))
      .then((response) => {
        if (!response.ok) {
          throw response;
        }
        return response.json();
      })
      .then((data) => camelcaseKeys(data, { deep: true }));
  }
};

let _counter = 0;

const mockData = () => {
  const mockLocations = [
    {
      "latitude": -6.22990,
      "longitude": 106.79921,
    },
    {
      "latitude": -6.24181,
      "longitude": 106.80255,
    },
    {
      "latitude": -6.266259,
      "longitude": 106.815933,
    },
  ];

  const index = _counter++ % mockLocations.length;
  return Promise.resolve(
    {
      "customer_type": null,
      "snapped_segment": [
        {
          "latitude": -6.229900000000001,
          "longitude": 106.79921
        },
        {
          "latitude": -6.23076,
          "longitude": 106.79880000000001
        }
      ],
      "images": {
        "service_type_logo": "https://i.gojekapi.com/darkroom/whimsy-p-id/v2/files/public/whimsy-p-id/160176ac-b503-4216-95e2-f3320fe9f6ba_GoRide-New_Trip-Tracker-Service-Type-Icon_16.svg",
        "driver_marker_icon": "https://i.gojekapi.com/darkroom/trip-tracker-production/v2/files/images/8a3d7446-670f-4644-b696-cf48e75476ea_bike.svg"
      },
      "sub_status": null,
      "route_polyline": "jvde@un|jSBaAPs@Z{@Nq@Ho@DmA[kAEGCY?cAI_DCuA|ACf@E|AKrCa@j@?bDQ|Fo@xGk@rD_@`Ei@xEa@rBIlBFfFb@",
      "route": {
        "dynamic": {
          "visibility": true,
          "polylines": [
            "zw_e@afzjSjDpAh@_CvAPbBACyFqB?@Q|IBt@CrAUdD{AvSgEl@GpCSbCGrCGbGBl@O|C@VCXIf@Wz@w@~DsCxGkElLcIbAy@x@y@\\c@r@sAb@aAp@i@DMLyAh@oBR]VWl@a@ZIh@Gh@A`@Fb@NNJxBlBzAn@bFjBZH^DfGA`@BDe@T_ADi@AwADyDA}ACI@Q"
          ]
        }
      },
      "source": {
        "name": "Name1",
        "address": "Address1",
        "latitude": -6.255302,
        "longitude": 106.810833,
        "note": "aa"
      },
      "base_maps": "google",
      "dropoff_eta": 6,
      "country_code": "ID",
      "status": "driver-found",
      "service_type": "go-ride",
      "driver": {
        "name": "AUTNeville",
        "vehicle_model": "Honda CBR",
        "registration_number": "WN6WD",
        "photograph_url": "https://i-integration.gojekapi.com/darkroom/driver-platform-integration-ktp/v2/images/public/52c404cf-0eb5-43fe-9cbb-5828ac17eec8_valid_selfie_gopay_KYC.jpg",
        "location": {
          "lat": mockLocations[index].latitude,
          "lng": mockLocations[index].longitude
        }
      },
      "pickup_eta": 8,
      "destination": {
        "name": "Name-6.266259,106.815933",
        "address": "Address-6.266259,106.815933",
        "latitude": -6.266259,
        "longitude": 106.815933,
        "note": "bb"
      },
      "customer_name": "AUTElvis"
  });
};
